<template>
	<div id="app">
        <v-app>
            <router-view />
        </v-app>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import types from './store/types'

export default {
	name: "App",
    computed: {
        ...mapGetters({
            rendered: types.appState.getters.isRendered,
            running: types.api.getters.isRunning,
            drawer: types.appBar.getters.drawer,
            hide: types.appBar.getters.hide,
            errorCode: types.api.getters.errorCode
        }),
        drawerModel: {
            set (drawer) {
                this.updateDrawer({ drawer })
            },
            get () {
                return this.drawer
            }
        },
        loading: {
            set () {
            },
            get () {
                return !this.rendered || this.running
            }
        },
        isiOS () {
            return /iPhone|iPad|iPod/i.test(navigator.userAgent);
        }
    },
    watch: {
        errorCode (value) {
            if (value !== 200) {
                /*
                this.$nextTick(() => {
                    this.$router.push('/splash')
                })
                */
            }
        }
    },
    methods: {
        ...mapActions({
            updateWidth: types.appState.actions.updateWidth,
            updateOffsetY: types.appState.actions.updateOffsetY,
            updateRendered: types.appState.actions.updateRendered,
            updateDrawer: types.appBar.actions.drawer
        }),
        winWidth () {
            const width = window.innerWidth
            this.updateWidth({ width })
        },
        onScroll () {
            const offsetY = window.pageYOffset
            this.updateOffsetY({ offsetY })
        }
    },
    created() {
        window.addEventListener("resize", this.winWidth)
        window.addEventListener('scroll', this.onScroll)
    },
    destroyed() {
        window.removeEventListener("resize", this.winWidth)
        window.removeEventListener('scroll', this.onScroll)
    },
    mounted () {
        this.winWidth()
        this.onScroll()
    }
}
</script>

<style scope lang="scss">
#app {
	/*
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	*/
    font-family: "NanumSquare", sans-serif !important;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

@media screen and (min-width: 501px) {
    #app{
        position:absolute;
        left:50%;
        transform:translate(-50%, 0);
        width:500px;
    }
}
// @media screen and (min-width: 501px) {
//     .rv {
//         width:100%;
//         margin: 0 auto; 
//     }
// }
/* .router_view.ios {
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch
} */
</style>
